import React, { createContext, useState } from "react";
import { Outlet } from "react-router-dom";
import { Box, Container } from "@mui/material";
import QMentisBreadCrumb from "../custom-components/QMentisBreadCrumb";

export const BugReportDataContext = createContext(null);

const BugReportPage = () => {
  const [bugReportData, setBugReportData] = useState({});
  const [enhancedBugReportData, setEnhancedBugReportData] = useState({});

  const breadCrumbs = [
    {
      title: "Input Bug Details",
      status:
        Object.keys(bugReportData).length > 0 ? "Completed" : "In Progress",
    },
    {
      title: "Enhance Bug Description",
      status:
        Object.keys(enhancedBugReportData).length > 0
          ? "Completed"
          : Object.keys(bugReportData).length > 0
            ? "In Progress"
            : "Not Started",
    },
  ];
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100vw",
        minWidth: 0, // Important: allows flex items to shrink below content size
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch", // Changed from center to stretch
        flexGrow: 1,
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      <Box sx={{
        width: "100%",
        minWidth: 0, // Important: allows shrinking
        overflow: "hidden",
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
      }}>
        {/* Fixed breadcrumb */}
        <Box
          sx={{
            position: "sticky",
            top: "0",
            width: "100%",
            minWidth: 0,
            zIndex: 1000,
            bgcolor: "white",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            overflow: "hidden",
            flexShrink: 0, // Prevent breadcrumb from shrinking
          }}
        >
          <QMentisBreadCrumb
            breadCrumbs={breadCrumbs}
            sx={{
              height: "56px",
              width: "100%",
              minWidth: 0,
            }}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            bgcolor: "#f6f3f2",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "stretch", // Changed from center to stretch
            overflowY: "auto",
            overflowX: "hidden",
            width: "100%",
            minWidth: 0, // Important: allows shrinking
            minHeight: "80vh",
            height: "80vh",
            flexGrow: 1,
            position: "relative",
            WebkitOverflowScrolling: "touch", 
            scrollbarWidth: "thin",           
            scrollbarColor: "#888 transparent", 
            "&::-webkit-scrollbar": {
              width: "4px",                   
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "4px",
              minHeight: "20px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        >
          <Container
            disableGutters // Remove default MUI Container padding that might cause overflow
            maxWidth={false} // Remove default max-width constraints
            sx={{
              width: "100%",
              minWidth: 0,
              padding: { xs: "8px", sm: "16px", md: "24px" },
              margin: 0, // Remove default margin
              boxSizing: "border-box",
              "&.MuiContainer-root": {
                paddingLeft: { xs: "8px", sm: "16px", md: "24px" },
                paddingRight: { xs: "8px", sm: "16px", md: "24px" },
              }
            }}
          >
            <BugReportDataContext.Provider
              value={{ setBugReportData, setEnhancedBugReportData }}
            >
              <Outlet />
            </BugReportDataContext.Provider>
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default BugReportPage;
